import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const DiscountCellContent: React.FC<DiscountCellContent.Props> = ({ item }) => {
	const language = useTypedSelector((state) => state.session.language);

	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.Discount];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item, language);
	}, [item, language]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace DiscountCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default DiscountCellContent;
